import { types } from 'mobx-state-tree';

export const GoodbyeAnswers = types
  .model('GoodbyeAnswers', {
    reason: types.optional(types.string, ''),
    action: types.optional(types.string, ''),
    improvements: types.optional(types.string, ''),
    rate: types.maybe(types.number),
  })
  .views(self => ({
    get isValid() {
      return (
        self.reason &&
        // self.action &&
        self.improvements &&
        typeof self.rate === 'number'
      );
    },
    get actionName() {
      switch (self.action) {
        case 'close account':
          return 'Close Account';
        case 'cancel subscription':
          return 'Cancel Subscription';
        default:
          return 'Before you go';
      }
    },
  }))
  .actions(self => ({
    setReason(val) {
      self.reason = val;
    },
    setAction(val) {
      self.action = val;
    },
    setImprovements(val) {
      self.improvements = val;
    },
    setRate(val) {
      self.rate = val;
    },
    reset() {
      self.reason = '';
      self.action = '';
      self.improvements = '';
      self.rate = null;
    },
  }));
